import "./ProfessionalHoods.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import MetodoOperativoAera from "./sections/MetodoOperativoAera";
import TechnicalMethodology from "./sections/TechnicalMethodology";
import TechnicalTreatment from "./sections/TechnicalTreatment";
import TechnicalInspection from "./sections/TechnicalInspection";
import SecurityEfficiencyContinuity from "./sections/SecurityEfficiencyContinuity";
import MetodoOperativo from "./sections/MetodoOperativo";
import Maintenance from "./sections/Maintenance";
import TechnicalDuctEngineering from "./sections/TechnicalDuctEngineering";
import RoboticEquipmentShowcase from "./sections/RoboticEquipmentShowcase";
import SafetyEfficiencyGrid from "./sections/SafetyEfficiencyGrid";
import Metodooperativoaera from "./sections/Metodooperativoaera";
import SettoriServiti from "./sections/SettoriServiti";
import TechnicalInspectionCTA from "./sections/TechnicalInspectionCTA";
export default function ProfessionalHoodsPage() {
  return <div>
      <Header />
      <MetodoOperativoAera />
      <TechnicalMethodology />
      <TechnicalTreatment />
      <RoboticEquipmentShowcase />
      <TechnicalInspection />
      <SafetyEfficiencyGrid />
      <SecurityEfficiencyContinuity />
      <Metodooperativoaera />
      <MetodoOperativo />
      <SettoriServiti />
      <TechnicalInspectionCTA />
      <Maintenance />
      <TechnicalDuctEngineering />
      <Footer />
    </div>;
}